import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('div', {
  className: 'flex w-full flex-col gap-8 m:hidden'
});

export const ListWrapper = createComponent('div', {
  className:
    'flex w-full items-center justify-between rounded-lg border border-grey-2 bg-grey-1 p-16'
});

export const ListContent = createComponent('div', {
  className: 'flex items-center gap-16'
});

export const ImageWrapper = createComponent('div', {
  className: 'flex h-32 w-32 items-center'
});

export const Label = createComponent('div', {
  className: 'text-blue-6 tl-body-m'
});
